module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Registration Form.82babcd5.pdf";